import React, { useCallback, useState, useEffect } from "react"
import { observer } from "mobx-react-lite"
import { StyleSheet, ScrollView } from "~/ui/primitives"
import styled, { useTheme } from "~/ui/styled"
import { useSafeAreaInsets } from "~/ui/safe-area"
import { Flex, ColumnFlex, StartFlex, CenterFlex, BetweenFlex, Button, Text, IconFont } from "~components/El"
import { LoginDeviceScreenProps } from "./types"
import { useModal } from "~hooks/useModal"
import { useStores } from "~models"
import { globalToast, globalSpinner, formatDate } from "~utils"


const containerStyle = { flex: 1, minHeight: 0, padding: "0 12px" } as const
const tips = [
    "注销设备后，该设备将需要重新登录才能访问你的账户。",
    "当前设备无法被注销。",
]

const ListContent = ({ data = [], onClick }) => {
  const theme = useTheme()
  return (
    <ColumnFlex width="100%">
        <BetweenFlex width="100%">
            <ColumnFlex padding="12px 0">
                <Text padding="3px 0" color={theme.colors.text} fontSize={theme.fontSizes.md} fontWeight="600">已登录设备</Text>
                <Text padding="3px 0" color={theme.colors.secondary} fontSize={theme.fontSizes.sm}>已登录设备</Text>
            </ColumnFlex>
            {data.length > 1 && (
                <Button
                    padding="6px 12px"
                    borderRadius="4px"
                    bg="rgba(250, 82, 81, 0.1)"
                    onClick={() => onClick(null)}
                >
                    <Text color={theme.colors.error} fontSize={theme.fontSizes.sm}>注销其它设备</Text>
                </Button>
            )}
        </BetweenFlex>
        {data.map((item, index) => {
            console.log(item.os,'os');
            
        return (
            <Button
                key={index}
                flexDirection="row"
                width="100%"
                padding="15px 0"
                borderTopWidth={StyleSheet.hairlineWidth}
                borderTopColor={theme.colors.border}
                borderTopStyle="solid"
                onClick={() => onClick(item)}
            >
                <Flex width="100%">
                    <CenterFlex
                        width="36px"
                        height="36px"
                        borderRadius="18px"
                        bg="rgba(49, 135, 226, 0.1)"
                    >
                        <IconFont name="gensuixitong" size={16} color="#3187e2" />
                    </CenterFlex>
                    <Flex flex={1} flexDirection="column" ml="10px">
                        <BetweenFlex width="100%">
                          <StartFlex width={'auto'} minWidth={'max-content'}> <Text  minWidth={'max-content'} fontSize={theme.fontSizes.md} color={theme.colors.text} fontWeight="600">{item.device_name || "-"}</Text></StartFlex> 
                            {item.is_current && (
                                <StartFlex>
                                    <CenterFlex width="auto" minWidth={'max-content'} padding="3px 6px"  borderRadius="9px" bg="rgba(7, 193, 96, 0.1)">
                                        <Text fontSize={theme.fontSizes.sm} color={theme.colors.primary}>当前设备</Text>
                                    </CenterFlex>
                                    <CenterFlex width="6px" height="6px" borderRadius="3px" bg={theme.colors.primary} ml="6px">
                                    </CenterFlex>
                                </StartFlex>
                            )}
                        </BetweenFlex>
                        <Text padding="3px 0" textAlign="left"  fontSize={theme.fontSizes.sm} color={theme.colors.secondary}>{item.os || "-"}</Text>
                        <StartFlex padding="3px 0">
                            <StartFlex>
                                <IconFont name="sssj1" size={10} color={theme.colors.secondary} />
                                <Text fontSize={theme.fontSizes.sm} color={theme.colors.secondary}>{item.last_country || "-"}</Text>
                            </StartFlex>
                            <StartFlex>
                                <IconFont name="sssj1" size={10} color={theme.colors.secondary} />
                                <Text fontSize={theme.fontSizes.sm} color={theme.colors.secondary}>最后活跃：{formatDate(item.last_login_at)}</Text>
                            </StartFlex>
                        </StartFlex>
                        <Text padding="3px 0" fontSize={theme.fontSizes.xs} color={theme.colors.infoText}>登录时间：{formatDate(item.first_login_at, "s")}</Text>
                        {!item.is_current && <Text mt="10px" fontSize={theme.fontSizes.sm} color={theme.colors.error}>注销此设备</Text>}
                    </Flex>
                </Flex>
               
            </Button>
        )
        })}
    </ColumnFlex>
    
  )
}


const LoginDevice: React.FC<LoginDeviceScreenProps> = ({ route }) => {
    const theme = useTheme()
    const insets = useSafeAreaInsets()
    const { Dialog} = useModal()
    const { apiStore } = useStores()
    // const [loading, setLoading] = useState(false)
    const [loginDevices, setLoginDevices] = useState([])
    const [onlineDevices, setOnlineDevices] = useState(0)
    const [totalDevices, setTotalDevices] = useState(0)
    const getLoginDevices = async () => {
        try {
            globalSpinner.show()
            const res = await apiStore.getLoginDevices()
            if (res.data) {
                setLoginDevices(res.data?.items || [])
                setOnlineDevices(res.data?.online)
                setTotalDevices(res.data?.total)
            }
            
            globalSpinner.close()
        } catch (error) {
            globalSpinner.close()
            globalToast.show(error?.message || "获取登录设备失败")
        }
    }
    useEffect(() => {
        getLoginDevices()
    }, [])
    const handlePress = useCallback((item) => {
        // console.log("item", item)
        if (item && item.is_current) return
        if (item) {
            Dialog.show({
                title: "温馨提示",
                content: `确定要注销“${item.device_name}”吗？`,
                loadingText: "注销中...",
                onConfirm: async () => {
                    apiStore.logoutLoginDevice({device_id: item.device_id}).then(() => {
                        globalToast.show("注销成功")
                        getLoginDevices()
                    }).catch((error) => {
                        globalToast.show(error?.message || "注销失败")
                    })
                },
            })
        } else {
            Dialog.show({
                title: "温馨提示",
                content: "确定要注销所有其它设备吗？这将强制其它设备重新登录。",
                loadingText: "注销中...",
                onConfirm: async () => {
                    apiStore.logoutAllLoginDevices().then(() => {
                        globalToast.show("注销成功")
                        getLoginDevices()
                    }).catch((error) => {
                        globalToast.show(error?.message || "注销失败")
                    })
                },
            })
        }
        
    }, [])
    return (
        <ScrollView
            style={{ ...containerStyle,paddingBottom: 20, marginBottom: insets.bottom  }}
            keyboardShouldPersistTaps="handled"
            showsVerticalScrollIndicator={false}
        >
            <Flex
                flexDirection="column"
                width="100%"
                mt="10px"
                padding="10px 12px"
                borderRadius="8px"
                bg={theme.colors.blockBackground}
            >
                <Text color={theme.colors.text} fontSize={theme.fontSizes.md} fontWeight="600">
                    <IconFont name="denglushebei" size={20} color={"#834f0c"} />&nbsp;&nbsp;设备安全
                </Text>
                <BetweenFlex
                    width="100%"
                    mt="10px"
                    gap="12px"
                >
                    <CenterFlex
                        flex={1}
                        flexDirection="column"
                        height="58px"
                        padding="10px"
                        borderRadius="8px"
                        bg="rgba(7, 193, 96, 0.1)"
                    >
                        <Text color={theme.colors.primary} fontSize={theme.fontSizes["2xl"]} fontWeight="600">{onlineDevices}</Text>
                        <Text color={theme.colors.primary} fontSize={theme.fontSizes.md}>在线设备</Text>
                    </CenterFlex>
                    <CenterFlex
                        flex={1}
                        flexDirection="column"
                        height="58px"
                        padding="10px"
                        borderRadius="8px"
                        bg="rgba(49, 135, 226, 0.1)"
                    >
                        <Text color="#3187e2" fontSize={theme.fontSizes["2xl"]} fontWeight="600">{totalDevices}</Text>
                        <Text color="#3187e2" fontSize={theme.fontSizes.md} >总设备数</Text>
                    </CenterFlex>
                </BetweenFlex>
            </Flex>
            <ColumnFlex
                width="100%"
                mt="10px"
                padding="0 12px"
                borderRadius="8px"
                bg={theme.colors.blockBackground}
            >
                <ListContent data={loginDevices} onClick={handlePress}/>
            </ColumnFlex>
            <Flex
                flexDirection="column"
                width="100%"
                mt="10px"
                padding="10px 12px"
                borderRadius="8px"
                bg="rgba(78, 152, 243, 0.1)"
            >
                <Text color={theme.colors.primaryText} fontSize={theme.fontSizes.md} fontWeight="600">
                <IconFont name="denglushebei" size={14} color={theme.colors.primaryText} />&nbsp;&nbsp;设备管理说明
                </Text>
                <Flex
                    flexDirection="column"
                    width="100%"
                    mt="10px"
                    pl="20px"
                    >
                    {tips.map((text, index) => (
                        <StartFlex key={index} >
                            <Text color={theme.colors.primaryText} fontSize={theme.fontSizes.sm} lineHeight="18px">
                                {text}
                            </Text>
                        </StartFlex>
                    ))}
                </Flex>
            </Flex>
        </ScrollView>
      )
}

export default observer(LoginDevice)
